/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { z } from 'zod';

export const CosmosApiPlatformSchema = z.enum([
  'mobile',
  'web',
  'desktop',
  'ios',
  'android',
]);

export const HomepageRequestHeadersSchema = z.object({
  'Content-Type': z.literal('application/json').default('application/json'),
  'X-API-Key': z.string().min(1, 'API key is required'),
});

export const HomepageQueryParamsSchema = z.object({
  platform: CosmosApiPlatformSchema,
  feature: z.string().min(1),
  lob: z.string().min(1),
  locale: z.string().min(1),
  geoId: z.string().min(1),
  currency: z.string().optional(),
});

export const HomepageRequestBodySchema = z.undefined().optional();

export const HomepageRequestSchema = z.object({
  headers: HomepageRequestHeadersSchema,
  params: HomepageQueryParamsSchema,
  body: HomepageRequestBodySchema,
});

export type TCosmosApiPlatform = z.infer<typeof CosmosApiPlatformSchema>;
export type THomepageRequestHeaders = z.infer<
  typeof HomepageRequestHeadersSchema
>;
export type THomepageQueryParams = z.infer<typeof HomepageQueryParamsSchema>;
export type THomepageRequestBody = z.infer<typeof HomepageRequestBodySchema>;
export type THomepageRequest = z.infer<typeof HomepageRequestSchema>;
